import React, { useState, Fragment } from 'react'
import { Formik } from 'formik'
import { ModalContent } from 'pobble-components/dist/modal'
import styles from './slide-form.styles'
import injectSheet from 'react-jss'
import FormRow from '../../../common/form-elements/form-row/form-row'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import CharactersCount from 'pobble-components/dist/form-elements/characters-count'
import {
  StickyEditor,
  EditorState,
  Controls,
  createStateFromHtml,
  stateToHTML
} from '../../../editor'
import * as Yup from 'yup'

const TITLE_MAX_LENGTH = 100
const TEXT_MAX_LENGTH = 1500

const SlideForm = ({ classes, initialValues, onSubmit, footer }) => {
  const [editorState, setEditorState] = useState(
    !initialValues.text
      ? EditorState.createEmpty()
      : createStateFromHtml(initialValues.text)
  )
  return (
    <Formik
      onSubmit={values =>
        onSubmit({
          ...values,
          text: editorState.getCurrentContent().getPlainText(),
          html: stateToHTML(editorState)
        })
      }
      initialValues={initialValues}
      validationSchema={Yup.object().shape({
        title: Yup.string().required(),
        url: Yup.string()
          .url()
          .required(),
        text: Yup.string().max(TEXT_MAX_LENGTH)
      })}>
      {formikProps => {
        const {
          handleSubmit,
          handleBlur,
          handleChange,
          values,
          errors,
          setFieldValue,
          touched
        } = formikProps
        return (
          <form onSubmit={handleSubmit} className="metrics__slide-form">
            <ModalContent legacy className={classes.modalContent}>
              <FormRow first>
                <FormLabel small spaceBetween htmlFor="videSlideUrl">
                  YouTube video url
                  <CharactersCount
                    value={values.title}
                    max={TITLE_MAX_LENGTH}
                  />
                </FormLabel>
                <FormInput
                  validationError={touched.url && errors.url}
                  placeholder="eg. https://www.youtube.com/watch?v=BqCdlFOkzFE"
                  name="url"
                  value={values.url}
                  id="videSlideUrl"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  autoFocus={true}
                />
              </FormRow>
              <FormRow>
                <FormLabel small spaceBetween htmlFor="videoSlideTitle">
                  Title
                  <CharactersCount
                    value={values.title}
                    max={TITLE_MAX_LENGTH}
                  />
                </FormLabel>
                <FormInput
                  validationError={touched.title && errors.title}
                  placeholder="eg. Pobble for Parents - Discover Pobble"
                  name="title"
                  value={values.title}
                  id="videoSlideTitle"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength={TITLE_MAX_LENGTH}
                />
              </FormRow>
              <FormRow>
                <FormLabel small spaceBetween htmlFor="videoSlideText">
                  Description
                  <CharactersCount value={values.text} max={TEXT_MAX_LENGTH} />
                </FormLabel>
                <StickyEditor
                  maxLength={TEXT_MAX_LENGTH}
                  error={!!errors.text}
                  placeholder="eg. The Roman Empire was the post-Roman Republic period ..."
                  controls={
                    <Fragment>
                      <Controls.Bold />
                      <Controls.Italic />
                      <Controls.Underline />
                      <Controls.Separator />
                      <Controls.UnorderedList />
                      <Controls.OrderedList />
                    </Fragment>
                  }
                  editorState={editorState}
                  onChange={newState => {
                    const plainText = newState
                      .getCurrentContent()
                      .getPlainText()
                    setFieldValue('text', plainText)
                    setEditorState(newState)
                  }}
                />
              </FormRow>
            </ModalContent>
            {footer(formikProps)}
          </form>
        )
      }}
    </Formik>
  )
}

export default injectSheet(styles)(SlideForm)
